import { render } from "./article-v1-overlay.vue?vue&type=template&id=b0aa4b7c"
import script from "./article-v1-overlay.vue?vue&type=script&lang=js"
export * from "./article-v1-overlay.vue?vue&type=script&lang=js"

import "./article-v1-overlay.vue?vue&type=style&index=0&id=b0aa4b7c&lang=sass"

import exportComponent from "../../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__